<template>
  <div class="design-input-container" :class="{ fullWidth }" @change="$emit('change')">
    <div class="design-input-box">
      <input type="text" v-model="value" class="design-input" @input="$emit('input')" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'DesignButton',
  props: {
    value: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      required: false
    }
  }
};
</script>
<style lang="scss" scoped>
.design-input-container {
  .design-input-box {
    width: auto;
    padding: 6.5px 10px;
    border: 1px solid #dbdade;
    border-radius: 6px;
    .design-input {
      font-size: 14px;
      line-height: 20px;
      width: 100%;
      border: none;
      color: #000000;
    }
  }
}
</style>
